import React from "react";
import ZarinpalImg from "../../assets/zplogo.png";
import SepImg from "../../assets/seplogo.png";

const gateways = [
  {
    id: "zarinpal",
    title: "درگاه زرین‌پال",
    subtitle: "پرداخت با کلیه کارت‌های عضو شتاب",
    icon: ZarinpalImg,
  },
  {
    id: "sep",
    title: "درگاه پرداخت سپ (سامان)",
    subtitle: "پرداخت با کلیه کارت‌های عضو شتاب",
    icon: SepImg,
  },
];

const GatewaySelector = ({ selectedGateway = "zarinpal", onChange, className = "" }) => {
  return (
    <div className={`gateway-selector-container ${className}`} dir="rtl">
      <label className="gateway-selector-label iran-sans">
        انتخاب درگاه پرداخت:
      </label>

      <div className="gateway-grid">
        {gateways.map((gw) => {
          const isSelected = selectedGateway === gw.id;
          return (
            <div
              key={gw.id}
              role="button"
              tabIndex={0}
              onClick={() => onChange && onChange(gw.id)}
              onKeyDown={(e) => {
                if (e.key === "Enter" || e.key === " ") {
                  onChange && onChange(gw.id);
                }
              }}
              className={`gateway-card ${isSelected ? "selected" : ""}`}
            >
              <div className="gateway-radio-indicator">
                <span className={`gateway-radio-dot ${isSelected ? "active" : ""}`} />
              </div>

              <div className="gateway-logo-wrapper">
                <img src={gw.icon} alt={gw.title} className="gateway-logo" />
              </div>

              <div className="gateway-info">
                <span className="gateway-title iran-sans">{gw.title}</span>
                <span className="gateway-subtitle iran-sans">{gw.subtitle}</span>
              </div>
            </div>
          );
        })}
      </div>

      <style>{`
        .gateway-selector-container {
          margin: 16px 0 8px;
          text-align: right;
        }

        .gateway-selector-label {
          display: block;
          font-size: 0.92rem;
          font-weight: 700;
          color: #053251;
          margin-bottom: 10px;
        }

        .gateway-grid {
          display: grid;
          grid-template-columns: repeat(2, 1fr);
          gap: 12px;
        }

        @media (max-width: 540px) {
          .gateway-grid {
            grid-template-columns: 1fr;
            gap: 10px;
          }
        }

        .gateway-card {
          display: flex;
          align-items: center;
          gap: 12px;
          padding: 12px 14px;
          border-radius: 16px;
          background: #ffffff;
          border: 2px solid rgba(5, 50, 81, 0.1);
          cursor: pointer;
          transition: all 0.25s cubic-bezier(0.4, 0, 0.2, 1);
          user-select: none;
          box-shadow: 0 2px 6px rgba(5, 50, 81, 0.03);
          outline: none;
        }

        .gateway-card:hover {
          border-color: rgba(124, 200, 144, 0.7);
          transform: translateY(-2px);
          box-shadow: 0 6px 16px rgba(5, 50, 81, 0.08);
        }

        .gateway-card.selected {
          border-color: #7cc890;
          background: linear-gradient(145deg, #ffffff 0%, rgba(124, 200, 144, 0.09) 100%);
          box-shadow: 0 6px 18px rgba(124, 200, 144, 0.28);
        }

        .gateway-radio-indicator {
          width: 20px;
          height: 20px;
          border-radius: 50%;
          border: 2px solid rgba(5, 50, 81, 0.25);
          display: flex;
          align-items: center;
          justify-content: center;
          flex-shrink: 0;
          transition: all 0.2s ease;
        }

        .gateway-card.selected .gateway-radio-indicator {
          border-color: #7cc890;
        }

        .gateway-radio-dot {
          width: 10px;
          height: 10px;
          border-radius: 50%;
          background: transparent;
          transition: all 0.2s ease;
        }

        .gateway-radio-dot.active {
          background: #7cc890;
        }

        .gateway-logo-wrapper {
          width: 44px;
          height: 44px;
          border-radius: 10px;
          background: #ffffff;
          border: 1px solid rgba(5, 50, 81, 0.08);
          display: flex;
          align-items: center;
          justify-content: center;
          padding: 4px;
          flex-shrink: 0;
        }

        .gateway-logo {
          width: 100%;
          height: 100%;
          object-fit: contain;
        }

        .gateway-info {
          display: flex;
          flex-direction: column;
          gap: 2px;
          overflow: hidden;
        }

        .gateway-title {
          font-size: 0.88rem;
          font-weight: 700;
          color: #053251;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
        }

        .gateway-subtitle {
          font-size: 0.72rem;
          color: #6a7f8e;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
        }
      `}</style>
    </div>
  );
};

export default GatewaySelector;
